import { useMutation } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { addUserTofund } from 'services/fund'
import posthog from 'posthog-js'

export default function useSetAddUser() {
    const navigate = useNavigate()
    const { mutate } = useMutation({
        mutationFn: (payload: IAddNewUserToFundPayload) => {
            return addUserTofund(payload)
        },
        onSuccess: (data, variables) => {
            posthog.capture('member_added', {
                fund_id: variables.moneyPool,
                number_of_shares: variables.number_of_shares,
                has_guarantor: Boolean(variables.guarantor),
                has_recommender: Boolean(variables.recommender),
            })
            toast.success('کاربر با موفقیت اضافه شد')
            navigate(-1)
        },
        onError: (error: any, variables) => {
            posthog.capture('member_add_failed', {
                fund_id: variables?.moneyPool,
                status: error?.response?.status,
                error_detail: error?.response?.data?.detail,
            })
            // The backend answers 406 with a machine-readable detail when the
            // phone number already has a poolship in this box; without mapping
            // these the user only ever saw the generic toast and kept retrying.
            const detail = error?.response?.data?.detail
            if (detail === 'Activate existed member.') {
                toast.error(
                    'این شماره قبلاً عضو این صندوق بوده است. برای فعال‌سازی دوباره، از فهرست اعضا روی عضو غیرفعال بزنید و «فعال‌سازی» را انتخاب کنید.',
                    { autoClose: 8000 }
                )
            } else if (detail === 'Poolship already exists.') {
                toast.error('این شماره هم‌اکنون عضو صندوق است.')
            } else {
                toast.error('مشکلی پیش آمده!')
            }
        },
    })
    return { mutate }
}
